

import {AnimatedRoutes} from '../../components/functional'
import React, { Component } from 'react';
import './index.scss';
import { observer, inject } from '../../../node_modules/mobx-react';

// import Login from '../../screens/login'
// import ResetRequest from '../../screens/reset/request'
// import Reset from "../../screens/reset/resetPassword";
// import { BrowserRouter as Router, Route, Link , Switch,matchPath} from "react-router-dom";





// let acces_token = "1ead5a9b06e35b8f94811c876fb3a19c10f1c47ba23e7ae51ebcf07bbf859196";

const Router  =
        AnimatedRoutes([
            // {route: '/',component:require('../../pages/login/1step').default, props:{}, order:0},
            // {route: '/login',component:require('../../pages/login/2step').default, props:{}, order:1},
            // {route: '/login2',component:require('../../pages/login/2step').default, props:{}, order:2},
            // {route: '/login1',component:require('../../pages/login/2step').default, props:{}, order:3},
            // {route: '/loginx',component:require('../../pages/login/2step').default, props:{}, order:4},
            // {route: '/login',component:require('../../screens/login').default, props:{}, order:0, },
            {route: '/',component:require('../../screens/login').default, props:{}, order:0},
            {route: '/reset',component:require('../../screens/reset/request').default, props:{}, order:1},
            {route: '/emailWasSend',component:require('../../screens/reset/success').default, props:{}, order:2},
            // {route: '/password/reset/'+acces_token,component:require('../../screens/reset/resetPassword').default, props:{}, order:3},
            { route: `/password/reset`,component:require('../../screens/reset/resetPassword').default, props:{}, order:3},
            //{route: '/success',component:require('../../screens/reset/success').default, props:{}, order:3},
        ],
        {
        // className:'login-routes',
        // parentClassName:'login-routes-parent',
        notFoundRoute:{component:require('../../screens/login').default, props:{}, redirect:'/'},
        animation:{
            type:'move', // rotate / scale / move / fade
            rorateAxis:'Y',
            duration:'0.45s',
        },
        showLinks:false,
        inRows:false,
        })
@inject('translate')
@inject('internal')
@observer
export default class LoginRoute extends Component {

    componentDidMount() {
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    }
 
    render() {
      return (
            // <Logg
            // footerTxt={this.props.translate.i18n.LOGIN.FOOTER}
            // // footerFlex={0.7}
            // // headerFlex={0.7}
            // >
            //     <Router />
            // </Logg>

            <Router />

            // <Switch>
            //     <Route exact path="/" component={Login} />
            //     <Route exact path="/login" component={Login} />
            //     <Route exact path="/reset" component={ResetRequest} />
            //     <Route exact path="/password/reset" component={Reset} />
            // </Switch>
      );
    }
  }




// WEBPACK FOOTER //
// ./src/routes/login/index.js